import { Component, EventEmitter, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IFileDownload, IExam } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-exam-feedback',
  templateUrl: './exam-feedback.component.html',
  styleUrls: ['./exam-feedback.component.scss']
})
export class ExamFeedbackComponent implements OnInit {

  exportedFile: IFileDownload = {
    fileName: '',
    size: 0,
    extension: '',
    file: undefined
  };
  exam: IExam = examDefault;

  value: any
  constructor(private popoverRef: PopoverRef<ExamFeedbackComponent>,
    private examService: ExamService, private snackBar: SnackbarService,) { }

  async ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
      this.value = JSON.parse(sessionStorage.getItem('value')) as number
      this.examService.getExamFeedbackReport(this.exam.id, this.value).then((s: IFileDownload) => {
        this.snackBar.success('Report Successfull');
        sessionStorage.removeItem('value');
        this.exportedFile = s;
      })
    }
  }

  close() {
    this.popoverRef.close();
  }

}
